const initialState = [];

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'LOCALES_SUCCESS') {
        return action.payload.locales;
    }

    return state;
}

export default reducer;
